import { render, staticRenderFns } from "./watchlistGridCards.vue?vue&type=template&id=f98500d8&scoped=true"
import script from "./watchlistGridCards.vue?vue&type=script&lang=js"
export * from "./watchlistGridCards.vue?vue&type=script&lang=js"
import style0 from "./watchlistGridCards.vue?vue&type=style&index=0&id=f98500d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98500d8",
  null
  
)

export default component.exports